

















































import Vue from 'vue';
import { Geek } from '@/models';
import { CustomAwardForm } from '@/models/gcoins';
import { typedStore, Actions } from '@/store';

export default Vue.extend({
  name: 'ExchangeCustomAwardModal',
  props: {
    geek: Object as () => Geek,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        description: '',
      } as CustomAwardForm,
    };
  },
  computed: {
    hasNoGCoins(): boolean {
      return this.geek.gCoins < 1;
    },
  },
  methods: {
    async checkForm() {
      const isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.requestCustomAward, this.form);
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
        this.$bvModal.hide('custom-award-modal');
      }
    },
     resetModal() {
      this.form.description = '';
    },
  },
});
